/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-throw-literal */
import React, {
  useState,
  useEffect,
  createContext,
  useContext,
  useCallback,
  useMemo,
} from "react"
import { auth } from "../firebase/firebaseConfig"
import { useAuthState } from "react-firebase-hooks/auth"
import { useProfile } from "./useProfile"

const AuthContext = createContext()

export function AuthProvider(props) {
  const [session, sessionLoading, sessionError] = useAuthState(auth)
  const [errorFirebase, setErrorFirebase] = useState(null)
  const [loginLoading, setLoginLoading] = useState(false)
  const { loadUsuario, clearUsuario } = useProfile(false)
  const [validatedUid, setValidatedUid] = useState(null)

  useEffect(() => {
    let active = true
    const refresh = async () => {
      if (!session) { clearUsuario(); setValidatedUid(null); return }
      try {
        if (!await loadUsuario()) throw new Error("Sin acceso a Zonda")
        if (active) setValidatedUid(session.uid)
      } catch (e) {
        if (active) {
          clearUsuario(); setValidatedUid(null); setErrorFirebase(e)
          await auth.signOut()
        }
      }
    }
    refresh()
    const timer = setInterval(refresh, 30000)
    window.addEventListener("focus", refresh)
    return () => { active = false; clearInterval(timer); window.removeEventListener("focus", refresh) }
  }, [session, loadUsuario, clearUsuario])

  const signIn = useCallback(async (email, password) => {
    setErrorFirebase(null)
    setLoginLoading(true)
    try {
      await auth.signInWithEmailAndPassword(email, password)
      // Validar el perfil local y limpiar permisos de sesiones anteriores.
      return
    } catch (e) {
      setErrorFirebase(e)
      await signOut()
    } finally {
      setLoginLoading(false)
    }
  }, [])

  const signOut = useCallback(async () => {
    try {
      clearUsuario()
      setValidatedUid(null)
      await auth.signOut()
    } catch (e) {
      console.error(e)
    }
  }, [])

  const memData = useMemo(() => {
    return {
      session: validatedUid !== session?.uid ? null : session,
      sessionLoading: sessionLoading || (!!session && validatedUid !== session.uid),
      userError: sessionError,
      signIn,
      signOut,
      errorFirebase,
      loginLoading,
    }
  }, [
    session,
    sessionLoading,
    sessionError,
    signIn,
    signOut,
    errorFirebase,
    loginLoading,
    validatedUid,
  ])

  return <AuthContext.Provider value={memData} {...props} />
}

export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) {
    throw "error: auth context not defined."
  }
  return context
}
